import 'src/locales'
import Router from './routes'
import TimeAgo from 'javascript-time-ago'
import ToasterContainer from './components/atoms/toaster-container'

import { msalInstance } from './utils/msal'
import { Worker } from '@react-pdf-viewer/core'
import { MsalProvider } from '@azure/msal-react'
import { BrowserRouter } from 'react-router-dom'
import { AntdProvider } from './theme/antd-provider'
import { localStorageGetItem } from './utils/storage'
import { AuthConsumer, AuthProvider } from './auth/context'
import { timeAgoLocales } from './locales/time-ago-locales'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutos
    },
  },
})

export default function App() {
  const lang = localStorageGetItem('i18nextLng', 'en-US')

  TimeAgo.setDefaultLocale(timeAgoLocales['en-US'].locale)
  TimeAgo.addLocale(timeAgoLocales['en-US'])

  TimeAgo.addDefaultLocale(
    timeAgoLocales[lang as keyof typeof timeAgoLocales] ??
      timeAgoLocales['en-US']
  )

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <AntdProvider>
              <BrowserRouter>
                <AuthConsumer>
                  <ToasterContainer />
                  <Router />
                </AuthConsumer>
              </BrowserRouter>
            </AntdProvider>

            {import.meta.env.MODE === 'development' && (
              <ReactQueryDevtools
                initialIsOpen={false}
                buttonPosition="bottom-left"
              />
            )}
          </QueryClientProvider>
        </AuthProvider>
      </MsalProvider>
    </Worker>
  )
}
